'use client';

import { Box, Button, Typography } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ElementType } from 'react';

export type SummaryTableSeeMoreAccountsButtonProps = {
  label: string;
  icon: ElementType<SvgIconProps>;
  onClick: () => void;
  fullWidth?: boolean;
};

export function SummaryTableSeeMoreAccountsButton({
  label,
  icon: Icon,
  onClick,
  fullWidth = false,
}: SummaryTableSeeMoreAccountsButtonProps) {
  return (
    <Box sx={{ display: 'flex', pt: 5, justifyContent: 'center' }}>
      <Button
        disableRipple
        disableFocusRipple
        sx={{
          backgroundColor: 'white',
          border: '1px solid',
          borderColor: 'primary.main',
          borderRadius: '4px',
          height: '48px',
          width: fullWidth ? '100%' : { xs: '100%', md: 'fit-content' },
          p: 3,
          color: 'primary.main',
          '&:disabled': {
            borderColor: 'neutral.light',
            backgroundColor: 'white',
            color: 'neutral.light',
          },
        }}
        onClick={onClick}
      >
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography
            variant="textSmall"
            sx={{
              textTransform: 'uppercase',
              fontWeight: 500,
              color: 'inherit',
            }}
          >
            {label}
          </Typography>
          <Icon
            sx={{
              fontSize: 16,
              color: 'inherit',
              verticalAlign: 'middle',
            }}
          />
        </Box>
      </Button>
    </Box>
  );
}
